import React from "react";
import ProjectCard from "./ProjectCard";
import projects from "../data/projects"; // Importez vos données de projet
import "../styles/ProjectPresentation-style.css";

const ProjectsPresentation = () => {
    return (
        <>
            <link href='https://fonts.googleapis.com/css?family=Lato:300,400,700' rel='stylesheet' type='text/css'/>
            <div className="ProjectsPresentationContent">
                <div id='stars'></div>
                <div id='stars2'></div>
                <div id='stars3'></div>

                <h1>My Projects</h1>
                <div className="project-list">
                    {projects.map((project, index) => (
                        <ProjectCard key={index} project={project} />
                    ))}
                </div>
            </div>
        </>
    );
};

export default ProjectsPresentation;
